import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        typeId: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      tagTypeList: [],
      // 标签类型

      // 表单
      form: {
        typeId: "",
        tag: ""
      },
      dialogVisible: false // 弹窗状态
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getTagType();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pn = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getTagList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.count;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getTagType: function getTagType() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getTagType();
            case 1:
              res = _context3.v;
              _this3.tagTypeList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    updateTagStatus: function updateTagStatus(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.updateTagStatus({
                id: row.id,
                status: row.status == -1 ? 0 : -1
              });
            case 1:
              _this4.getData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              res = null;
              if (!_this5.form.id) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this5.$api.updateTag(_this5.form);
            case 1:
              res = _context5.v;
              _context5.n = 4;
              break;
            case 2:
              _context5.n = 3;
              return _this5.$api.addTag(_this5.form);
            case 3:
              res = _context5.v;
            case 4:
              _this5.dialogVisible = false;
              _this5.form = {};
              _this5.getData();
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};